import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import reducer from './reducer'
import saga from './saga'
import * as constants from './constants'

export { reducer, saga, constants }

export default Loadable(() => import('./Files'))
